export default "<app-header></app-header>\r\n<app-main-menus></app-main-menus>";